import { SearchableSelect } from "@risalabs_frontend_org/oasis-ui-kit";

/** Props for the primary Dx searchable dropdown. */
export interface PrimaryDxSelectProps {
  options: { value: string; label: string }[];
  value: string;
  onOptionChange: (option: { name: string; value: string }) => void;
}

/**
 * Searchable dropdown for selecting the primary Dx code.
 *
 * @param props - Dropdown options, value, and change handler.
 */
export const PrimaryDxSelect = ({
  options,
  value,
  onOptionChange,
}: PrimaryDxSelectProps) => (
  <div className="primaryDx-select w-full">
    <SearchableSelect
      id="primaryDx"
      label="Primary Dx Code"
      placeholder="Select the DX Code"
      searchPlaceholder="Search Dx Code"
      options={options}
      value={value}
      onOptionChange={onOptionChange}
    />
  </div>
);
